import { useEffect, useState } from 'react'

import { SCREEN_SIZES } from '@theme'

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const media = window.matchMedia(query)
    if (media.matches !== matches) {
      setMatches(media.matches)
    }
    const listener = () => setMatches(media.matches)
    window.addEventListener('resize', listener)
    return () => window.removeEventListener('resize', listener)
  }, [matches, query])

  return matches
}

export const useIsMobile = () =>
  useMediaQuery(`(max-width: ${SCREEN_SIZES.mobileL}px)`)
export const useIsMobileXL = () =>
  useMediaQuery(`(max-width: ${SCREEN_SIZES.mobileXL}px)`)
export const useIsTablet = () =>
  useMediaQuery(`(max-width: ${SCREEN_SIZES.tablet}px)`)
export const useIsTabletS = () =>
  useMediaQuery(`(min-width: ${SCREEN_SIZES.tabletS}px)`)
export const useIsTabletXS = () =>
  useMediaQuery(`(max-width: ${SCREEN_SIZES.tabletXS}px)`)
export const useIsTabletM = () =>
  useMediaQuery(`(max-width: ${SCREEN_SIZES.tabletM}px)`)
export const useIsTabletL = () =>
  useMediaQuery(`(max-width: ${SCREEN_SIZES.tabletL}px)`)
export const useIsSmallerThenLaptop = () =>
  useMediaQuery(`(max-width: ${SCREEN_SIZES.laptop}px)`)
export const useIsLaptop = () =>
  useMediaQuery(`(min-width: ${SCREEN_SIZES.laptop}px)`)
export const useIsLaptopL = () =>
  useMediaQuery(`(min-width: ${SCREEN_SIZES.laptopL}px)`)
export const useIsLaptopM = () =>
  useMediaQuery(`(min-width: ${SCREEN_SIZES.laptopM}px)`)
export const useIsDesktop = () =>
  useMediaQuery(`(min-width: ${SCREEN_SIZES.desktop}px)`)
export const useIsDesktopS = () =>
  useMediaQuery(`(min-width: ${SCREEN_SIZES.desktopS}px)`)
